export default [
  {
    path: '/iso-templates',
    name: 'iso-templates',
    component: () => import('@/views/iso/templtes/IsoTemplates.vue'),
    meta: {
      title: 'ISO Templates',
      requiresAuth: true,
      action: 'browes',
    },
  },
  {
    path: '/iso-templates/edit/:id',
    name: 'edit-iso-template',
    component: () => import('@/views/iso/templtes/EditIsoTemplate.vue'),
    meta: {
      title: 'Edit ISO Template',
      requiresAuth: true,
      action: 'browes',
    },
  },
  {
    path: '/iso-scope-codes',
    name: 'iso-scope-codes',
    component: () => import('@/views/iso/scope-codes/ScopesList.vue'),
    meta: {
      title: 'ISO Scope Codes',
      requiresAuth: true,
      action: 'browes',
    },
  },
  {
    path: '/iso-scope-codes/edit/:id',
    name: 'edit-iso-scope-codes',
    component: () => import('@/views/iso/scope-codes/EditScopes.vue'),
    meta: {
      title: 'Edit ISO Scope Codes',
      requiresAuth: true,
      action: 'browes',
    },
  },
  {
    path: '/iso-assign-personal',
    name: 'iso-assign-personal',
    component: () => import('@/views/iso/assign-personal/AssignPersonal.vue'),
    meta: {
      title: 'ISO Assign Personal',
      requiresAuth: true,
      action: 'view',
    },
  },
]
